import { setViewport } from '@actions/creators';
import { VIEWPORTS, BROWSER_STORAGE_KEYS } from '@constants';
import { setBrowserStorageItem } from '@utils/browserStorage';

const { viewportKey } = BROWSER_STORAGE_KEYS;

export const useViewport = (width, dispatch) => {
    if (!parseInt(width)) {
        console.error(`Provided width must be a number, received value ${width} with type ${typeof width}`);
        return null;
    }

    const numWidth = parseInt(width);
    const { mobile, tablet, desktop } = VIEWPORTS;
    let viewport = '';

    if (numWidth <= 480) {
        viewport = mobile;
    } else if (numWidth > 480 && numWidth <= 560) {
        viewport = tablet;
    } else {
        viewport = desktop;
    }

    dispatch(setViewport(viewport));
    setBrowserStorageItem(viewportKey, viewport);

    return viewport;
};

